import * as React from 'react';

import { DataTable, Table } from '../components/common';
import { IconButton } from '../components/buttons';
import { IconDownload } from '../components/icons';
import Utils, { PolicyStatus } from '../common/utils';

interface Props {
	className?: string;
	policies: CustomerPolicy[];
	onRowClick?: (e: any, row?: any) => void;
	onDownloadClick: (e: any, row?: any) => void;
	loading: boolean;
}
const PolicyList = (props: Props) => {
	return (
		<DataTable
			className={props.className}
			TableComponent={p => <Table isDataTable={true}>{p.children}</Table>}
			columns={[
				{
					accessor: 'id',
					show: false
				},
				{
					Header: 'Policy #',
					accessor: 'number'
				},
				{
					Header: 'Start Date',
					accessor: 'effectiveDate',
					Cell: (row: any) => Utils.formatDateAsUTC(row.value)
				},
				{
					Header: 'End Date',
					accessor: 'endDate',
					Cell: (row: any) => Utils.formatDateAsUTC(row.value)
				},
				{
					Header: 'Coverage Amount',
					accessor: 'coverageAmount',
					Cell: (row: any) => Utils.formatCurrency(row.value, 0)
				},
				{
					Header: 'Premium',
					accessor: 'rate',
					Cell: (row: any) => Utils.formatCurrency(row.value) + '/Monthly'
				},
				{
					Header: 'Status',
					accessor: 'statusId',
					Cell: (row: any) => {
						if (row.value === PolicyStatus.Active) {
							return 'Active';
						} else if (row.value === PolicyStatus.Inactive) {
							return 'Inactive';
						} else if (row.value === PolicyStatus.Canceled) {
							return 'Canceled';
						} else {
							return '';
						}
					}
				},
				{
					Header: 'Actions',
					className: 'p-0 td-actions',
					width: 103,
					Cell: (row: any) => {
						if (row.original.isActive) {
							return (
								<div>
									<IconButton
										title="Download policy"
										className="btn-icon-secondary btn-icon-td"
										onClick={(e: any) => { props.onDownloadClick(e, row.original); }}
									>
										<IconDownload />
									</IconButton>
								</div>
							);
						} else {
							return null;
						}
					}
				}
			]}
			data={props.policies}
			getTrProps={(state: any, rowInfo: any, column: any) => {
				return { className: 'tr' };
			}}
			noDataText="No policies found"
			showPagination={false}
			loading={props.loading}
		/>
	);
};
export default PolicyList;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/policy/PolicyList.tsx